import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';

import { BaseSelectFilter } from '../shared/base-select-filter';

export function GroupByFilter({
  autoSelectIfEmpty,
  useContextFn,
  errorMessages = {},
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    groupBy: number;
    setGroupBy: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { UnitLaborLevel } = useProLaborLevelDesignations();

  const options = [
    { id: '0', label: 'Shift', value: 0 },
    { id: '1', label: UnitLaborLevel, value: 1 },
  ];

  const { groupBy: value, setGroupBy: onChange } = useContextFn();
  const helperText = errorMessages['groupBy'];
  return (
    <BaseSelectFilter
      autoSelectIfEmpty={autoSelectIfEmpty}
      label="Group By"
      options={options}
      value={value}
      onChange={onChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
